import { Box, NativeSelect, FormControl, InputLabel } from '@mui/material'
import React from 'react'
import { ECO, LUBRICANT, PERFORMANCE, TYREHUB } from '../../constant/htg-companies'
import moment from 'moment'

const SearchBar = ({ data, setData }) => {
  const handleChange = (event) => {
    const v = parseInt(event.target.value)
    const update = { [event.target.name]: isNaN(v) ? event.target.value : v }
    if (event.target.name === 'startMonth' && data.endMonth < v) {
      update.endMonth = v
    } else if (event.target.name === 'endMonth' && data.startMonth > v) {
      update.startMonth = v
    } else if (event.target.name === 'year' && v === new Date().getFullYear()) {
      const currentMonth = new Date().getMonth() + 1

      if (data.startMonth > currentMonth) {
        update.startMonth = currentMonth
      }

      if (data.endMonth > currentMonth) {
        update.endMonth = currentMonth
      }
    }

    setData({ ...data, ...update })
  }

  const today = new Date()

  const maxMonth = data.year < today.getFullYear() ? 12 : today.getMonth() + 1

  const months = Array.from({ length: maxMonth }, (_, i) => i + 1)

  return (
    <Box>
      <FormControl sx={{ m: 1, minWidth: 80 }} size='small'>
        <InputLabel variant='standard' id='search-htg'>
          Company
        </InputLabel>
        <NativeSelect
          labelId='search-htg'
          name='htgCompany'
          value={data.htgCompany}
          onChange={handleChange}
        >
          <option value={TYREHUB}>Tyrehub</option>
          <option value={PERFORMANCE}>Performance</option>
          <option value={LUBRICANT}>Lubricant</option>
          <option value={ECO}>Eco Battery</option>
        </NativeSelect>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 60 }} size='small'>
        <InputLabel variant='standard' id='search-year'>
          Year
        </InputLabel>
        <NativeSelect labelId='search-year' name='year' value={data.year} onChange={handleChange}>
          <option value={today.getFullYear()}>2022</option>
          <option value={today.getFullYear() - 1}>2021</option>
          <option value={today.getFullYear() - 2}>2020</option>
        </NativeSelect>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 50 }} size='small'>
        <InputLabel variant='standard' id='search-start-month'>
          From
        </InputLabel>
        <NativeSelect
          labelId='search-start-month'
          name='startMonth'
          value={data.startMonth}
          onChange={handleChange}
        >
          {months.map((m) => (
            <option key={m} value={m}>
              {moment(m, 'M').format('MMM')}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 50 }} size='small'>
        <InputLabel variant='standard' id='search-end-month'>
          To
        </InputLabel>
        <NativeSelect
          labelId='search-end-month'
          name='endMonth'
          value={data.endMonth}
          onChange={handleChange}
        >
          {months.map((m) => (
            <option key={m} value={m}>
              {moment(m, 'M').format('MMM')}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    </Box>
  )
}

export default SearchBar
